import { baromoneyTransferSettingService } from '@/services/baromoney-transfer-setting';
import BaromoneyTransferSettingVM from '@/view-model/baromoney-transfer-setting/BaromoneyTransferSettingVM';
import { defineStore } from 'pinia';
import { ref } from 'vue';
/** 초기화 되지 않는 데이터 */
export const prevData = {
    pageSizeType: '',
    pageNumber: 0,
    fromDate: '',
    toDate: '',
};
// 캐쉬 이동 설정
export const piniaBaromoneyTransferSetting = defineStore('baromoneyTransferSetting', () => {
    // state
    /**
     * 검색
     */
    const filterOption = ref({
        pageSizeType: '20',
        pageNumber: 1,
        useType: 'USE',
        ViewsType: 'ALL',
        fromDate: '',
        toDate: '',
        searchType: 'MEMO',
        searchText: '',
    });
    /**
     * 리스트
     */
    const itemList = ref([]);
    /**
     * 상세정보
     */
    const itemDetail = ref(new BaromoneyTransferSettingVM());
    /**
     * 페이지네이션
     */
    const paginationData = ref({});
    /**
     * 리스트 조회
     */
    const getItemList = async () => {
        const response = await baromoneyTransferSettingService.getItemList({
            pageSize: filterOption.value.pageSizeType,
            pageNumber: filterOption.value.pageNumber,
            status: filterOption.value.useType,
            type: filterOption.value.ViewsType,
            fromDate: filterOption.value.fromDate,
            toDate: filterOption.value.toDate,
            searchType: filterOption.value.searchType,
            searchText: filterOption.value.searchText,
        });
        itemList.value = response.list;
        paginationData.value = response.paginationData;
    };
    /**
     * 단건 조회
     */
    const getItem = async (id) => {
        const response = await baromoneyTransferSettingService.getItem(id);
        itemDetail.value = new BaromoneyTransferSettingVM(response);
        return response;
    };
    /**
     * 단건 초기화
     */
    const clear = () => {
        itemDetail.value = new BaromoneyTransferSettingVM();
    };
    /**
     * 필터 옵션 업데이트
     */
    const updateFilterOption = async (newOptions) => {
        filterOption.value = {
            ...filterOption.value,
            ...newOptions,
        };
    };
    return {
        filterOption,
        itemList,
        itemDetail,
        paginationData,
        getItemList,
        updateFilterOption,
        getItem,
        clear,
    };
});
